import React, { memo, useEffect, useRef, useState } from 'react';
import { LoadingSpinner, Text, useTheme } from '@adc/parallax-component-library';
import { Button } from 'Components/utility';
import i18n from 'Utilities/i18n';
import { Container } from './styles';
import useDatePicker from './useDatePicker';
const DatePicker = ({ onSave, onCancel, isVisible, title, initialDate }) => {
    const theme = useTheme();
    const [isDelayedVisible, setIsDelayedVisible] = useState(false);
    const elemRefYear = useRef(null);
    const elemRefMonth = useRef(null);
    const elemRefDay = useRef(null);
    const { dateString, elems, config, selectInitialDate, loading } = useDatePicker(elemRefYear, elemRefMonth, elemRefDay, isVisible, initialDate);
    const resetToDate = (date) => {
        selectInitialDate(elems, config, date);
    };
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                setIsDelayedVisible(true);
            }, 200);
            return () => clearTimeout(timer);
        }
        else {
            setIsDelayedVisible(false);
        }
    }, [isVisible]);
    return (React.createElement(Container, { backgroundColor: theme['surface.containerSecondary'].get(), neutral50: theme['neutral.50'].get(), text100: theme['text.100'].get(), selectorBorderColor: theme['text.100'].get() },
        React.createElement("div", { className: "date-selector-container", style: {
                left: isDelayedVisible ? 0 : -window.screen.width,
            } },
            loading && (React.createElement("div", { className: "spinner" },
                React.createElement(LoadingSpinner, { testID: "DatePicker.spinner" }))),
            React.createElement("div", { className: "date-selector-header", style: { opacity: loading ? 0 : 1 } },
                React.createElement(Button, { variant: "tertiary", onPress: () => onCancel && onCancel(), testID: "DatePicker.btnCancel", "aria-label": "", label: "" }),
                React.createElement(Text, { fontSize: "$bodyBase.medium", fontWeight: "$bodyBase.medium", color: "$text.100", testID: "DatePicker.title", marginTop: "$3" }, title),
                React.createElement(Button, { variant: "tertiary", onPress: () => {
                        if (dateString) {
                            onSave(dateString, resetToDate);
                        }
                    }, testID: "DatePicker.btnDone", "aria-label": i18n.t('Global.microcopy.common.done'), label: i18n.t('Global.microcopy.common.done') })),
            React.createElement("div", { id: "DatePicker.dateSelector", className: "date-selector" },
                React.createElement("div", { id: "DatePicker.selector", className: "selector" }),
                React.createElement("div", { className: "month", id: "DatePicker.month", ref: elemRefMonth }),
                React.createElement("div", { className: "day", id: "DatePicker.day", ref: elemRefDay }),
                React.createElement("div", { className: "year", id: "DatePicker.year", ref: elemRefYear })))));
};
export default memo(DatePicker);
